import { productsSliderInit } from '../sliders/sliders';

const $relatedProductsSection = $('.js-product-related-products');
const $relatedProductsHolder = $relatedProductsSection.find('.js-slider-products');

if ($relatedProductsSection.length) {
  const productId = $relatedProductsSection.data('product-id');

  $.ajax({
    url: `/recommendations/products.json?product_id=${productId}`,
    success(res) {
      const products = res.products;

      if (products != undefined && products.length) {
        let html = '';

        products.forEach((product) => {
          let productTitle = product.title;
          let itemShoeColor = '';
          let itemMaterialDescription = '';
          let descriptionTags = '';
          let productPrice = `<span class="price__amount"><span class="money">${Shopify.formatMoney(
            product.variants[0].price,
            Shopify.current_money_format
          )}</span></span>`;
          let productHtml = $('#product-item-template').text();
          const imageUrl =
            product.featured_image ||
            'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_220x.gif';

          product.tags.forEach((tag) => {
            if (tag.indexOf('SHORTNAME|') != -1) {
              productTitle = tag.split('SHORTNAME|')[1];
            }

            if (tag.indexOf('SHOECOLOUR|') != -1) {
              itemShoeColor += tag.split('SHOECOLOUR|')[1] + ' ';
            }

            if (tag.indexOf('MATERIALDESCRIPTION|') != -1) {
              itemMaterialDescription += tag.split('MATERIALDESCRIPTION|')[1] + ' ';
            }
          });

          if (itemShoeColor != '') {
            descriptionTags += itemShoeColor;
          }

          if (itemMaterialDescription != '') {
            descriptionTags += itemMaterialDescription;
          }

          if (product.compare_at_price_min > product.price_min) {
            productPrice = `
              <del class="price__amount">
                <span class="money">
                  ${Shopify.formatMoney(product.compare_at_price_min, Shopify.current_money_format).replace('.00', '')}
                </span>
              </del>

              <ins class="price__amount">
                <span class="money">
                  ${Shopify.formatMoney(product.price_min, Shopify.current_money_format).replace('.00', '')}
                </span><!-- /.money -->
              </ins>
            `;
          }

          productHtml = productHtml.replace(/{{url}}/g, product.url);
          productHtml = productHtml.replace(/{{imageUrl}}/g, imageUrl);
          productHtml = productHtml.replace(/{{title}}/g, productTitle);
          productHtml = productHtml.replace(/{{descriptionTags}}/g, descriptionTags);
          productHtml = productHtml.replace(/{{price}}/g, productPrice);
          productHtml = productHtml.replace(/{{soldOutClass}}/g, product.available ? '' : 'product-item--sold-out');

          html += productHtml;
        });

        html = $(html);
        html.appendTo($relatedProductsHolder);
        productsSliderInit();
      }
    },
  });
}
